<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("customermanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item class="black">
        <router-link :to="`${routerName.customerList}`">
          {{ t("customerlist") }}
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("workstationmanagement")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 15%"
        v-model:value="deviceID"
        :placeholder="t('enterworkstationnumber')"
      />
      <a-button class="searchBtn" @click="search" :disabled="disabledButton">{{
        t("search")
      }}</a-button>
      <a-button
        class="searchBtn addBtn"
        @click="addWorkStationF"
        :disabled="disabledButton"
        >{{ t("newworkstation") }}</a-button
      >
    </div>
    <a-table
      :data-source="dataList"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 1400 }"
    >
      <template #bodyCell="{ record, column }">
        <template v-if="column.dataIndex === 'deviceCode'">
          <div
            style="align-items: center"
            v-if="changeWorkStationVin != record.id"
          >
            <span>{{ record.deviceCode }}</span>
          </div>
          <div style="align-items: center" v-else>
            <div :placeholder="t('enterdevicenumber')" v-if="isNewList">
              {{ editWorkForm.deviceCode }}
            </div>
            <a-input
              v-model:value="addWorkForm.deviceCode"
              :placeholder="t('enterdevicenumber')"
              v-else
            />
          </div>
        </template>
        <template v-if="column.dataIndex === 'name'">
          <div
            style="align-items: center"
            v-if="changeWorkStationVin != record.id"
          >
            <span>{{ record.name }}</span>
          </div>
          <div style="align-items: center" v-else>
            <a-input
              v-model:value="editWorkForm.name"
              :placeholder="t('inputenamehint')"
              v-if="isNewList"
            />
            <a-input
              v-model:value="addWorkForm.name"
              :placeholder="t('inputenamehint')"
              v-else
            />
          </div>
        </template>
        <template v-if="column.dataIndex === 'model'">
          <div>
            <div
              style="align-items: center"
              v-if="changeWorkStationVin != record.id"
            >
              <span>{{ record.model }}</span>
            </div>
            <div style="align-items: center" v-else>
              <a-select
                v-model:value="editWorkForm.model"
                :placeholder="t('pleaseselct')"
                size="large"
                v-if="isNewList"
                @change="valueChange(editWorkForm.model, record)"
              >
                <a-select-option
                  v-for="item in CarModelOptions"
                  :key="item.value"
                  v-model:value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
              <a-select
                v-model:value="addWorkForm.model"
                :placeholder="t('pleaseselct')"
                size="large"
                @change="valueChange(addWorkForm.model, record)"
                v-else
              >
                <a-select-option
                  v-for="item in CarModelOptions"
                  :key="item.value"
                  v-model:value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
          </div>
        </template>
        <template v-if="column.dataIndex === 'isEnable'">
          <div
            style="align-items: center"
            v-if="changeWorkStationVin != record.id"
          >
            <span v-if="record.isEnable">{{ t("enable") }}</span>
            <span v-else>{{ t("disable") }}</span>
          </div>
          <div style="align-items: center" v-else>
            <a-select
              v-model:value="editWorkForm.isEnable"
              :placeholder="t('pleaseselct')"
              size="large"
              v-if="isNewList"
            >
              <a-select-option
                v-for="item in isEnableOptions"
                :key="item.value"
                :label="item.label"
                v-model:value="item.value"
                >{{ item.label }}</a-select-option
              >
            </a-select>
            <a-select
              v-model:value="addWorkForm.isEnable"
              :placeholder="t('pleaseselct')"
              size="large"
              v-else
            >
              <a-select-option
                v-for="item in isEnableOptions"
                :key="item.value"
                v-model:value="item.value"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </div>
        </template>
        <template v-if="column.dataIndex === 'workModel'">
          <div
            style="align-items: center"
            v-if="changeWorkStationVin != record.id"
          >
            <span v-if="record.workModel === 0">{{ t("fullsupply") }}</span>
            <span v-if="record.workModel === 1">{{ t("chargeonly") }}</span>
          </div>
          <div style="align-items: center" v-else>
            <a-select
              v-model:value="editWorkForm.workModel"
              :placeholder="t('pleaseselct')"
              size="large"
              v-if="isNewList"
            >
              <a-select-option
                v-for="item in WorkingModeOptions"
                :key="item.value"
                v-model:value="item.value"
                >{{ item.label }}</a-select-option
              >
            </a-select>
            <a-select
              v-model:value="addWorkForm.workModel"
              :placeholder="t('pleaseselct')"
              size="large"
              v-else
            >
              <a-select-option
                v-for="item in WorkingModeOptions"
                :key="item.value"
                v-model:value="item.value"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </div>
        </template>
        <template v-if="column.dataIndex === 'delayReleaseTime'">
          <div
            style="align-items: center"
            v-if="changeWorkStationVin != record.id"
          >
            <span v-if="record.delayReleaseTime"
              >{{ record.delayReleaseTime }}{{ t("minute") }}</span
            >
          </div>
          <div style="align-items: center" v-else>
            <a-select
              v-model:value="editWorkForm.delayReleaseTime"
              :placeholder="t('pleaseselct')"
              size="large"
              v-if="isNewList"
            >
              <a-select-option
                v-for="(item, index) in releaseList"
                :key="index"
                v-model:value="item.release"
                >{{ item.release }}</a-select-option
              >
            </a-select>
            <a-select
              v-model:value="addWorkForm.delayReleaseTime"
              :placeholder="t('pleaseselct')"
              size="large"
              v-else
            >
              <a-select-option
                v-for="(item, index) in releaseList"
                :key="index"
                v-model:value="item.release"
                >{{ item.release }}</a-select-option
              >
            </a-select>
          </div>
        </template>
        <template v-if="column.dataIndex === 'channel'">
          <div
            style="align-items: center"
            v-if="changeWorkStationVin != record.id"
          >
            <span>{{ record.channel }}</span>
          </div>
          <div style="align-items: center" v-else>
            <a-select
              v-model:value="editWorkForm.channel"
              :placeholder="t('pleaseselct')"
              size="large"
              v-if="isNewList"
            >
              <a-select-option
                v-for="(item, index) in userDefinedList"
                :key="index"
                :value="item.channel"
                :disabled="item.disable"
                >{{ item.channel }}</a-select-option
              >
            </a-select>
            <a-select
              v-model:value="addWorkForm.channel"
              :placeholder="t('pleaseselct')"
              size="large"
              v-else
            >
              <a-select-option
                v-for="(item, index) in userDefinedList"
                :key="index"
                :value="item.channel"
                :disabled="item.disable"
                >{{ item.channel }}</a-select-option
              >
            </a-select>
          </div>
        </template>
        <template v-if="column.dataIndex === 'status'">
          <div>{{ workStatus(record.status) }}</div>
        </template>
        <template v-else-if="column.dataIndex === 'car_model'">
          <div class="operate">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="checkItem(record)">
                <img
                  v-if="record.id !== checkedId"
                  src="../assets/images/notclicked.png"
                  alt=""
                />
                <img v-else src="../assets/images/clicked.png" alt="" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    v-if="changeWorkStationVin != record.id"
                    key="0"
                    :disabled="disabledButton"
                    @click="resetStatus(record.id, editWorkForm)"
                  >
                    {{ t("manualreset") }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item
                    key="1"
                    v-if="changeWorkStationVin != record.id"
                    :disabled="disabledButton"
                    @click="editWorkStationF(record)"
                    >{{ t("edit") }}</a-menu-item
                  >
                  <a-menu-item
                    v-if="!(changeWorkStationVin != record.id) && record.id"
                    key="2"
                    @click="saveWorkStationF(editWorkForm)"
                    >{{ t("save") }}</a-menu-item
                  >
                  <a-menu-item
                    v-if="!(changeWorkStationVin != record.id) && !record.id"
                    key="3"
                    @click="SaveAddWorkStationF(addWorkForm)"
                    >{{ t("save") }}</a-menu-item
                  >
                  <a-menu-divider />
                  <a-menu-item
                    v-if="!(changeWorkStationVin != record.id) && record.id"
                    key="4"
                    @click="CancelWorkStationF"
                    >{{ t("cancellation") }}</a-menu-item
                  >
                  <a-menu-item
                    v-if="!(changeWorkStationVin != record.id) && !record.id"
                    key="5"
                    @click="CancelAddWorkStationF"
                  >
                    {{ t("cancellation") }}
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(total) => `${t('intotal')} ${total}${t('article')}`"
      v-model:current="stationParam.page"
      v-model:pageSize="stationParam.size"
      :total="totalNum * 1"
      size="small"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { CarModelOptions } from "@/constant/WorkStationOption";
import routerName from "@/router/routerName";
import { clickTarget } from "@/utils/MyUtils";
import { message } from "ant-design-vue";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "WorkstationManagement",
  setup() {
    const { t } = useI18n();

    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const route = useRoute();
    const router = useRouter();
    const deviceID = ref("");
    const workStatus = (type) => {
      let status = "";
      switch (type) {
        case 0:
          status = t("occupy");
          break;
        case 1:
          status = t("idle");
          break;
        case 2:
          status = t("notavailable");
          break;
      }

      return status;
    };

    const isEnableOptions = ref([
      {
        value: true,
        label: t("enable"),
      },
      {
        value: false,
        label: t("disable"),
      },
    ]);

    const WorkingModeOptions = ref([
      {
        value: 0,
        label: t("fullsupply"),
      },
      {
        value: 1,
        label: t("chargeonly"),
      },
    ]);

    const stationParam = ref({
      vin: "",
      page: 1,
      size: 20,
    });
    const disabledButton = ref(false);
    const repairCycle = ref("");
    const repairCycleMin = ref(0);
    const newChannel = ref(); // 暂时无用
    const newCarModel = ref("");
    const newIsEnable = ref("");
    const newName = ref("");
    const orgId_id = route.query.id;
    const dataList = ref([]);
    const totalNum = ref(0);
    const getListData = () => {
      const param = {
        orgId: Number(orgId_id),
        deviceCode: deviceID.value,
        page: stationParam.value.page,
        size: stationParam.value.size,
      };
      Api.getWorkstationList(param).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataList.value = res.result;
          totalNum.value = res.total_num;
          console.log(dataList.value);
        } else {
          message.error(res.err_msg);
        }
      });
    };
    // 搜索按钮
    const search = () => {
      stationParam.value.page = 1;
      getListData();
    };

    // 修改工作站修复周期操作
    const repairCycleChange = () => {
      repairCycleMin.value = Number(repairCycle.value);
    };

    // 工作站对象 编辑对象
    const editWorkForm = ref({
      id: 0,
      name: "",
      model: "",
      isEnable: true,
      channel: 0,
      release: 1,
      status: 1,
      deviceCode: "",
      workModel: 0, //工作模式
      delayReleaseTime: 1, //延迟释放
      orgId: Number(orgId_id),
    });
    // 延迟释放时间
    const releaseList = ref([]);
    for (let i = 0; i < 31; i++) {
      const e = {
        release: i,
      };
      releaseList.value.push(e);
    }
    // 工作站对象 新建对象
    const addWorkForm = ref({
      orgId: Number(orgId_id),
      name: "",
      model: "SC50",
      isEnable: true,
      channel: 0,
      status: 1,
      deviceCode: "",
      workModel: 0,
      delayReleaseTime: 0,
    });

    const userDefinedList = ref([]);
    const valueChange = (val, info) => {
      gettingOptions(val, info);
      for (let a = 0; a < userDefinedList.value.length; a++) {
        if (userDefinedList.value[a].disable === false) {
          console.log(userDefinedList.value[a].channel);
          editWorkForm.value.channel = userDefinedList.value[a].channel;
          break;
        }
      }
    };
    const gettingOptions = (val, info) => {
      addWorkForm.value.channel = 0;
      editWorkForm.value.channel = 0;
      const sc80D = dataList.value.filter((item) => item.model === "SC80");
      const sc50D = dataList.value.filter((item) => item.model === "SC50");

      // 初始化信道选项
      userDefinedList.value = [];
      for (let channelvalue = 0; channelvalue < 35; channelvalue++) {
        const element = {
          channel: channelvalue,
          disable: false,
        };
        userDefinedList.value.push(element);
      }

      if (val === "SC80" && sc80D && sc80D?.length > 0) {
        let isSetChannel = false;
        let isSetEditChannel = false;
        for (let i = 0; i < userDefinedList.value.length; i++) {
          for (let j = 0; j < sc80D.length; j++) {
            if (userDefinedList.value[i].channel === sc80D[j].channel) {
              if (info) {
                if (val == info?.model) {
                  if (sc80D[j].id != info?.id) {
                    userDefinedList.value[i].disable = true;
                  }
                } else {
                  userDefinedList.value[i].disable = true;
                }
              } else {
                userDefinedList.value[i].disable = true;
              }
            }
          }
          if (!isSetChannel && !userDefinedList.value[i].disable) {
            addWorkForm.value.channel = userDefinedList.value[i].channel;
            isSetChannel = true;
          }
          if (!isSetEditChannel && !userDefinedList.value[i].disable) {
            editWorkForm.value.channel = userDefinedList.value[i].channel;
            isSetEditChannel = true;
          }
        }
      }
      if (val === "SC50" && sc50D && sc50D?.length > 0) {
        let isSetChannel = false;
        let isSetEditChannel = false;
        for (let i = 0; i < userDefinedList.value.length; i++) {
          for (let j = 0; j < sc50D.length; j++) {
            if (userDefinedList.value[i].channel === sc50D[j].channel) {
              if (info) {
                if (val == info?.model) {
                  if (sc50D[j].id != info?.id) {
                    userDefinedList.value[i].disable = true;
                  }
                } else {
                  userDefinedList.value[i].disable = true;
                }
              } else {
                userDefinedList.value[i].disable = true;
              }
            }
          }
          if (!isSetChannel && !userDefinedList.value[i].disable) {
            addWorkForm.value.channel = userDefinedList.value[i].channel;
            isSetChannel = true;
          }
          if (!isSetEditChannel && !userDefinedList.value[i].disable) {
            editWorkForm.value.channel = userDefinedList.value[i].channel;
            isSetEditChannel = true;
          }
        }
      }
    };

    const channelList = ref([]);

    // 编辑工作站
    const changeWorkStationVin = ref();
    const nameChanged = ref(""); //存储原工作站name
    const isNewList = ref(true); //判断input框是新建还是编辑
    // 编辑按钮
    const editWorkStationF = (num) => {
      gettingOptions(num.model, num);
      changeWorkStationVin.value = num.id;
      disabledButton.value = true;
      isNewList.value = true;
      dataList.value.some((item) => {
        if (item.id == num.id) {
          editWorkForm.value.id = item.id;
          editWorkForm.value.name = item.name;
          editWorkForm.value.model = item.model;
          editWorkForm.value.isEnable = item.isEnable;
          editWorkForm.value.channel = item.channel;
          editWorkForm.value.status = item.status;
          editWorkForm.value.deviceCode = item.deviceCode;
          editWorkForm.value.workModel = item.workModel; //工作模式
          editWorkForm.value.delayReleaseTime = item.delayReleaseTime; //延迟释放
          nameChanged.value = editWorkForm.value.name;
        }
      });
    };
    // 提交保存接口
    const editWorkFormF = (form) => {
      if (clickTarget(50)) return true;
      saveFunction(form);
    };
    const saveFunction = (form) => {
      Api.editWorkStation(form).then((val) => {
        if (val.err_no == 200) {
          message.success(t("savetime"));
          changeWorkStationVin.value = undefined;
          disabledButton.value = false;
          getListData();
          gettingOptions(form.model);
        } else {
          message.error(val.err_msg);
        }
      });
    };
    // 保存按钮
    const saveWorkStationF = (editWorkForm) => {
      editWorkFormF(editWorkForm);
    };

    // 取消按钮
    const CancelWorkStationF = () => {
      changeWorkStationVin.value = undefined;
      disabledButton.value = false;
    };
    // 添加功能的取消按钮
    const CancelAddWorkStationF = () => {
      addWorkForm.value.deviceCode = "";
      addWorkForm.value.name = "";
      addWorkForm.value.model = "SC50";
      addWorkForm.value.isEnable = true;
      addWorkForm.value.channel = 0;
      addWorkForm.value.workModel = 0; //工作模式
      addWorkForm.value.delayReleaseTime = 1; //延迟释放
      disabledButton.value = false;
      dataList.value.shift();
      disabledButton.value = false;
    };
    // 添加工作站
    const addWorkStationF = () => {
      gettingOptions("SC50");
      isNewList.value = false;
      disabledButton.value = true;
      dataList.value.unshift(addWorkForm);
    };
    // 添加功能的保存按钮
    const SaveAddWorkStationF = (addWorkFormP) => {
      if (clickTarget(500)) return;
      Api.addWorkStation(addWorkFormP).then((val) => {
        if (val.err_no == 200) {
          addWorkForm.value.deviceCode = "";
          addWorkForm.value.name = "";
          addWorkForm.value.model = "SC50";
          addWorkForm.value.isEnable = true;
          addWorkForm.value.channel = 0;
          addWorkForm.value.workModel = 0; //工作模式
          addWorkForm.value.delayReleaseTime = 1; //延迟释放
          disabledButton.value = false;
          getListData();
          message.success(t("savetime"));
          setTimeout(() => {
            router.go(0);
          }, 500);
        } else {
          message.error(val.err_msg);
        }
      });
    };
    // 手动复位
    const resetStatus = (string, editWorkForm1) => {
      dataList.value.some((item) => {
        if (item.id == string) {
          editWorkForm.value.id = item.id;
          editWorkForm.value.name = item.name;
          editWorkForm.value.model = item.model;
          editWorkForm.value.isEnable = item.isEnable;
          editWorkForm.value.channel = item.channel;
          editWorkForm.value.status = 1;
          editWorkForm.value.deviceCode = item.deviceCode;
          editWorkForm.value.workModel = item.workModel; //工作模式
          editWorkForm.value.delayReleaseTime = item.delayReleaseTime; //延迟释放
          nameChanged.value = editWorkForm.value.name;
        }
      });
      editWorkFormF(editWorkForm1);
    };
    const handlePaginationChange = () => {
      getListData();
    };
    const columns = [
      {
        title: t("equipmentnumber"),
        dataIndex: "deviceCode",
        key: "deviceCode",
        align: "center",
        width: 200,
      },
      {
        title: t("workstationname"),
        dataIndex: "name",
        key: "name",
        align: "center",
        width: 200,
      },
      {
        title: t("adaptivevehiclemodel"),
        dataIndex: "model",
        key: "model",
        align: "center",
        width: 200,
      },
      {
        title: t("enableornot"),
        dataIndex: "isEnable",
        key: "isEnable",
        align: "center",
      },
      {
        title: t("workingmode"),
        dataIndex: "workModel",
        key: "workModel",
        align: "center",
      },
      {
        title: t("delayedrelease"),
        dataIndex: "delayReleaseTime",
        key: "delayReleaseTime",
        align: "center",
      },
      {
        title: t("channel"),
        dataIndex: "channel",
        key: "channel",
        align: "center",
      },
      {
        title: t("state"),
        dataIndex: "status",
        key: "status",
        align: "center",
      },
      {
        title: t("operate"),
        dataIndex: "car_model",
        key: "car_model",
        align: "center",
      },
    ];
    const checkedId = ref("");
    const checkItem = (value) => {
      checkedId.value = value.id;
    };
    onMounted(() => {
      getListData();
    });
    return {
      checkedId,
      checkItem,
      columns,
      deviceID,
      disabledButton,
      dataList,
      totalNum,
      repairCycle,
      repairCycleMin,
      newChannel,
      newCarModel,
      CarModelOptions,
      newIsEnable,
      isEnableOptions,
      WorkingModeOptions,
      newName,
      changeWorkStationVin,
      editWorkForm,
      addWorkForm,
      isNewList,
      channelList,
      releaseList,
      getListData,
      editWorkStationF,
      repairCycleChange,
      addWorkStationF,
      CancelWorkStationF,
      workStatus,
      search,
      saveWorkStationF,
      resetStatus,
      SaveAddWorkStationF,
      CancelAddWorkStationF,
      valueChange,
      userDefinedList,
      stationParam,
      handlePaginationChange,
      maxHeight,
      routerName,
      t,
    };
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.addBtn {
  position: absolute;
  margin-top: 13px;
  right: 40px;
}
</style>
